module.exports = __webpack_public_path__ + "img/promotions-madness.0b6219f1.png";